import request from '../request'

export default {
  testCSV: async function (process) {
    return await request.get('process/testCSV', {
      params: {
        processId: process
      }
    })
  },

  testCSV5: async function (process) {
    return await request.get('process/testCSV5', {
      params: {
        processId: process
      }
    })
  },

  getProcesses: function () {
    return request.get('process')
  },

  deleteProcess: function (process) {
    return request.delete(`process/${process.ID_PROCESO}`)
  },

  createProcess: function (data) {
    return request.post('process/new', data)
  },
  premodule: function (data) {
    return request.post('process/premodule', data)
  },
  module1: function (data) {
    return request.post('process/module1', data)
  },
  module2: function (data) {
    return request.post('process/module2', data)
  },
  module3: function (data) {
    return request.post('process/module3', data)
  },
  module4: function (data) {
    return request.post('process/module4', data)
  },
  module5: function (data) {
    return request.post('process/module5', data)
  },
  getResults: function (process, numModule, extrainfo) {
    return request.get('process/resultsModule', {
      params: {
        processId: process,
        numModule: numModule,
        extrainfo: extrainfo
      }
    })
  }
}
